<template>
	<div class="newstar">
		<svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="8px" height="8px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
			<rect x="0" y="37.719" width="99.567" height="10.581"/>
			<rect x="0" y="37.717" transform="matrix(0.5998 -0.8002 0.8002 0.5998 -14.489 57.0463)" width="99.566" height="10.58"/>
			<rect x="0" y="37.718" transform="matrix(-0.6014 -0.7989 0.7989 -0.6014 45.3646 108.6455)" width="99.567" height="10.577"/>
		</svg>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
	name:"newStar"
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	rect
		fill: $color-text-m
</style>



// WEBPACK FOOTER //
// src/common/only-svg/newstar-svg.vue